module.exports = __webpack_public_path__ + "img/notcertificate.388942e5.png";